import { PostStrExpressionSplice } from "./PostStrExpressionSplice";
import AxiosConfig from "../../../../config/AxiosConfigJs";
import { QueryResultInfoFactory } from "../Model/QueryResultInfoFactory";


/// <summary>
/// 关键字查询服务Util
/// </summary>
export class KeyWordServiceUtility {


	constructor() {
		this.centerPointX = -1;
		this.centerPointY = -1;
		this.completeEvent = null;
		this.count = -1;
		this.keyWord = null;
		this.level = -1;
		this.maxLat = -1;
		this.maxLon = -1;
		this.minLat = -1;
		this.minLon = -1;
		this.queryFault = null;
		this.queryTerminal = "10000";
		this.queryType = -1;
		this.radiusDistance = -1;
		this.specifyAdminCode = null;
		this.start = -1;
		this.tdtURL = "http://api.tianditu.gov.cn/search";
		this.token=null;
	}
	

	/**
	 * 查询
	 * @param {*} succeedCallback 
	 * @param {*} errorCallback 
	 */
	Query(succeedCallback, errorCallback) {
		let postStrExpSplice = this.GetPostStrExpression();
		let postString = postStrExpSplice.GetExpression();

		AxiosConfig.nationalTDTConfig
			.get(this.tdtURL, { params: { random: Math.random(), postStr: postString, type: "query" ,tk:this.token} })
			.then(function (response) {
				if (response != null) {
					let resultObj = response.data;
					let curInfo = QueryResultInfoFactory.GetQueryResultInfo(resultObj);
					if(succeedCallback)
					{
						succeedCallback(curInfo);
					}
					
				}
			})

			.catch(function (error) {
				if(errorCallback)
				{
					errorCallback(error.message);
				}
				
			});
	}

	GetPostStrExpression() {
		let postStrExpSplice = new PostStrExpressionSplice();
		postStrExpSplice.keyWord = this.keyWord;
		postStrExpSplice.level = this.level;
		postStrExpSplice.minLat = this.minLat;
		postStrExpSplice.maxLat = this.maxLat;
		postStrExpSplice.minLon = this.minLon;
		postStrExpSplice.maxLon = this.maxLon;
		postStrExpSplice.queryType = this.queryType;
		postStrExpSplice.count = this.count;
		postStrExpSplice.start = this.start;
		postStrExpSplice.centerPointX = this.centerPointX;
		postStrExpSplice.centerPointY = this.centerPointY;
		postStrExpSplice.queryTerminal = this.queryTerminal;
		postStrExpSplice.radiusDistance = this.radiusDistance;
		postStrExpSplice.specifyAdminCode = this.specifyAdminCode;
		
		return postStrExpSplice;
	}

}
